import lazyLoad from '@app/lazyload';
import fade from '@app/fade';
import gallery from '@app/gallery';
import menu from '@app/menu';
import masonry from '@app/masonry';
import carousel from '@app/carousel';
import transition from '@app/transition';

transition.init();

export const initApp = () => {
  lazyLoad.init();
  fade.init();
  gallery.init();
  menu.init();
  masonry.init();
  carousel.init();
}

initApp();

